var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div id=\"summary-performance-chart\" class=\"summary-charts\"></div>\n    <div id=\"summary-evaluation-chart\" class=\"summary-charts\"></div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"performance") : depth0)) != null ? lookupProperty(stack1,"values") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":24,"column":11}}})) != null ? stack1 : "")
    + "    <button id=\"summary-invasion-button\" class=\"summary-button\" style=\"display: none;margin-top: -20px\">\n        "
    + container.escapeExpression(__default(require("./i18n.js")).call(alias1,"Action.ShowInvasionIndicator",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":26,"column":8},"end":{"line":26,"column":47}}}))
    + "\n    </button>\n\n";
},"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"summary-performance\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"performance") : depth0)) != null ? lookupProperty(stack1,"values") : stack1),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":12},"end":{"line":22,"column":21}}})) != null ? stack1 : "")
    + "        </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <div class=\"col-xs-2 summary-label label-inline\">\n                    "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0))
    + "\n                </div>\n                <div class=\"col-xs-4 summary-value value-inline\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"hint") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":20},"end":{"line":16,"column":27}}})) != null ? stack1 : "")
    + "                    "
    + ((stack1 = __default(require("./gt.js")).call(alias3,(depth0 != null ? lookupProperty(depth0,"symbol") : depth0),0,{"name":"gt","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":20},"end":{"line":17,"column":97}}})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = __default(require("./is.js")).call(alias3,(depth0 != null ? lookupProperty(depth0,"symbol") : depth0),0,{"name":"is","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":20},"end":{"line":18,"column":71}}})) != null ? stack1 : "")
    + "\n                    "
    + ((stack1 = __default(require("./lt.js")).call(alias3,(depth0 != null ? lookupProperty(depth0,"symbol") : depth0),0,{"name":"lt","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":20},"end":{"line":19,"column":99}}})) != null ? stack1 : "")
    + "\n                    "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"value") : depth0), depth0))
    + "\n                </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <div class=\"btn btn-xs btn-tooltip\" data-toggle=\"tooltip\" data-placement=\"top\" title=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"hint") : depth0), depth0))
    + "\"\n                             data-original-title=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"hint") : depth0), depth0))
    + "\">\n                            <i class=\"fa fa-info\"></i>\n                        </div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "<i class=\"fa fa-caret-up\" style=\"color: #27AE60\"></i> ";
},"5":function(container,depth0,helpers,partials,data) {
    return "<i class=\"fa fa-minus\"></i> ";
},"6":function(container,depth0,helpers,partials,data) {
    return "<i class=\"fa fa-caret-down\" style=\"color: #C0392B\"></i> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"performance") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":29,"column":7}}})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/summary-performance.hbs
// module id = PBkQ
// module chunks = 1